// =============== SORTING FUNCTIONS =========================== //

//This takes in two row objects and a column to compare by (ex. Date)
//It then compares whether the value of that column is greater for one row or another
export function descendingComparator(rowA, rowB, orderByColumn) {
  if (rowB[orderByColumn] < rowA[orderByColumn]) {
    return -1;
  }
  if (rowB[orderByColumn] > rowA[orderByColumn]) {
    return 1;
  }
  return 0;
}

//If the sort order is descending, this uses the descending comparator. 
//Otherwise, it reverses output from descending comparator.
export function getComparator(order, orderByColumn) {
  return order === 'desc'
    ? (rowA, rowB) => descendingComparator(rowA, rowB, orderByColumn)
    : (rowA, rowB) => -descendingComparator(rowA, rowB, orderByColumn);
}

//Specific sorting algorithm
export function stableSort(array, comparator) {
  if (array) {
    //For each element in OG array, you insert subarray [element, index in main array]
    const stabilizedThis = array.map((el, index) => [el, index]);

    //.sort() takes in a compare function. 
    //(a, b) are two consecutive indices (and it'll go through all indices in array like that)
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
}

// ========== END SORTING FUNCTIONS ================ //